
import { Component, Vue } from 'vue-property-decorator';

import { deleteResource, getResourcePagingNew, getResourcesNew } from '../../../../framework/client/resource';
import { Option } from '../../../../../common/framework/model/Option';
import { errorToast, successToast } from '../../../../application/service/toast_service';
import { VatRate } from '../../../../../common/application/model/VatRate';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import ParameterService from "../../../service/parameter_service";
import { dateToDbDateString } from '../../../../../common/framework/util/convert';

@Component
export default class VatRates extends Vue {
    readonly resourceType = ApplicationResource.VAT_RATE;
    parameterService = new ParameterService(this.resourceType);

    local = {
        rows: [] as VatRate[],
        total: 0,
        loading: false,
        selected: undefined as VatRate | undefined,
        parameters: this.parameterService.get(),
    };

    async mounted() {
        this.local.loading = true;
        await this.loadAsyncData();
        this.local.loading = false;
    }

    async onPageChange(page: number) {
        this.local.parameters.page = page;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }

    async onSortChange(field: string, order: 'desc' | 'asc') {
        this.local.parameters.sortField = field;
        this.local.parameters.sortOrder = order;
        await this.resetPagingAndLoadData();
    }

    add() {
        this.$router.push(`/${this.resourceType}/add`);
    }

    edit(id?: string) {
        if (id) {
            this.$router.push(`/${this.resourceType}/${id}/edit`);
        } else if (this.local.selected) {
            this.$router.push(`/${this.resourceType}/${this.local.selected.id}/edit`);
        }
    }

    confirmDelete() {
        this.$buefy.dialog.confirm({
            title: this.$t('title.confirmDelete').toString(),
            message: this.$t('message.confirmDelete').toString(),
            cancelText: this.$t('button.cancel').toString(),
            confirmText: this.$t('button.ok').toString(),
            type: 'is-success',
            onConfirm: async () => {
                if (this.local.selected) {
                    try {
                        await deleteResource(this.resourceType, this.local.selected.id);
                        successToast(this, 'message.resourceDeleted');
                        await this.loadAsyncData();
                    } catch (e) {
                        errorToast(this);
                    }
                }
            },
        });
    }
    
    onRowClick(row: Option) {
        if (this.local.selected && row.id === this.local.selected.id) {
            this.local.selected = undefined;
        }
    }


    dateToString(date: string | undefined) {
        if (!date) {
            return '';
        }
        return dateToDbDateString(new Date(date));
    }

    private async loadAsyncData() {
        const backendParameters = this.parameterService.getBackendParameters();
        this.local.total = (
            await getResourcePagingNew(this.resourceType, backendParameters)
        ).rowCount;

        this.local.rows = await getResourcesNew<VatRate>(
            this.resourceType,
            this.local.parameters.page,
            backendParameters
        );

        if (this.local && this.local.rows.indexOf(this.local.selected!!) == -1) {
            this.local.selected = undefined;
        }
    }

    private async resetPagingAndLoadData() {
        this.local.parameters.page = 1;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }
}
